import apiServices, { connectorClient } from '../utils/axios';

export const fetchApsHubs = async (connectionId) => {
  const res = await connectorClient(connectionId).get('aps/api/hubs');
  return res.data;
};

export const fetchApsProjects = async (connectionId, hubId) => {
  if (!hubId) return [];
  const res = await connectorClient(connectionId).get(`/aps/api/hubs/${hubId}/projects`);
  return res.data;
};

export const fetchApsIssues = async (connectionId, payload) => {
  console.log('payload before send', payload);
  const res = await connectorClient(connectionId).post(`/aps/api/project/issues`, payload);
  return res.data;
};

export const fetchApsRFIs = async (connectionId, payload) => {
  console.log('payload before send', payload);
  const res = await connectorClient(connectionId).post(`/aps/api/project/rfis`, payload);
  return res.data;
};

export const fetchApsSubmittals = async (connectionId, payload) => {
  const res = await connectorClient(connectionId).post(`/aps/api/project/submittals`, payload);
  return res.data;
};

export const fetchApsFormList = async (connectionId, projectId) => {
  const res = await connectorClient(connectionId).get(`/aps/api/project/${projectId}/form-templates`);
  return res.data;
};

export const fetchApsExtractFormData = async (connectionId, payload) => {
  const res = await connectorClient(connectionId).post(`/aps/api/project/forms/templates/${payload.templateId}`, payload);
  return res.data;
};

export const fetchAPSFolderContent = async (connectionId, { hub_id, project_id, folder_id }) => {
  const url = folder_id
    ? `/aps/api/hub/${hub_id}/project/${project_id}/folder/${folder_id}`
    : `/aps/api/hub/${hub_id}/project/${project_id}/folder`;

  const res = await connectorClient(connectionId).get(url);
  return res.data;
};

export const fetchApsExtractFiles = async (connectionId, payload) => {
  const res = await connectorClient(connectionId).post(`/aps/api/project/files`, payload);
  return res.data;
};

export const fetchApsExtractFileCCT = async (connectionId, payload) => {
  const res = await connectorClient(connectionId).post(`/aps/api/project/files/cct`, payload);
  return res.data;
};

export const fetchExtractFileExcel = async ({ file, type }) => {
  console.log({ file, type });
  const formData = new FormData();
  formData.append('file', file);
  formData.append('payload', JSON.stringify({ type }));
  const res = await apiServices.post(`/aps/project/excel`, formData);
  return res.data;
};

export const fetchApsDownload = async ({type, id}) => {
  const res = await apiServices.get(`/aps/download?category=${type}&id_datacategory=${id}`, {responseType: "blob"});
  return res.data;
};

export const fetchApsUpload = async (access_token) => {
  console.log(access_token)
  const res = await apiServices.post(`/gdrive/test-upload`, {access_token});
  return res.data;
};

export const fetchApsScheduleExtraction = async (connectionId, payload) => {
  const res = await connectorClient(connectionId).post(`/aps/api/schedule`, payload);
  return res.data;
};

